import React from "react";
import { Redirect, Route } from "react-router-dom";
import { inject, observer } from "mobx-react";
import AuthStore from "../../stores/auth/auth.store";

interface Props {
  authStore?: AuthStore;
  component?: any;
  path: string;
  location?: any;
  redirectTo?: any;
}

@inject("authStore")
@observer
class PublicOnlyRoute extends React.PureComponent<Props, any> {
  render() {
    const { component: Component, redirectTo, ...rest } = this.props;
    const isAuthenticated = this.props!.authStore!.isAuthenticated;
    // const referrer = localStorage.getItem("referrer");
    const _redirectTo = redirectTo || "/addons";

    return (
      <Route
        exact
        {...rest}
        render={(props) =>
          !isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect to={_redirectTo} />
          )
        }
      />
    );
  }
}

export default PublicOnlyRoute;
